import codeMasterModel from "../../models/common/code-master.model";
import log from "../../utils/logger";
import SingleSelectCommonComponentView from "./single-select-common-component.view";

/**
 * @deprecated
 */
export default function codeMasterDropdownInputComponent() {
  let _attrs;
  let _options = [];
  let _countryCode = '';
  let getCodeMasterByCategory = () => {
    if (_countryCode && _countryCode != '') {

    }
    codeMasterModel.getByCategory(
      (result) => {
        if (result)
          _options = result;
        else _options = []
      },
      (error) => {
        _options = [];
        log.e({ error: error, params: { category: _attrs.category, countryCode: _countryCode } });
      },
      { category: _attrs.category, countryCode: _countryCode }
    );
  }

  return {
    oninit: ({ attrs }) => {
      _attrs = attrs;
      _countryCode = _attrs.countryCode;
      getCodeMasterByCategory();
    },
    view: ({ attrs }) => {
      _attrs = attrs;
      if (_countryCode != _attrs.countryCode) {
        _countryCode = _attrs.countryCode;
        getCodeMasterByCategory(_attrs);
      }

      return m('.col',
        m('label.form-label',
          _attrs.label,
          _attrs.mandatory ? m('span', { "style": { "color": "red" } }, '*') : ''),
        m(SingleSelectCommonComponentView, {
          disabled: false,
          iconList: [],
          items: _options,
          selectedItem: _options.find((item) => item.code === attrs.selectedValue),
          handleSelect: (sItem) => {
            _attrs.onchange(sItem.code);
          }
        }),
        _attrs.validate && !_attrs.isvalid &&
        m('.invalid-feedback.fs-6.d-block',
          m('small', _attrs.errorMessage)
        )
      );
    }
  };
}
